module.exports = __webpack_public_path__ + "static/media/issues-with-management.1d9a23a9.jpg";